import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core'
import {
  ContainerModel,
  ExpandableTextModel,
  FilterOptionModel,
  FilterableContainer,
  FilterableGrid,
  GridContainer,
  ImageWithButtonsModel,
  LinkModel,
  TwoColumnContainerModel,
  MessageModel,
  VideoPlayerCard
} from '@flocasts/experience-service-types'
import { trackById } from 'src/app/shared/utility-functions/track-by-id.utility'

/**
 * Layout for content with a right side rail.
 * Tablet screen sizes have leaderboard ads at the bottom of the screen.
 */
@Component({
  selector: 'flo-content-right-rail-layout',
  templateUrl: './content-right-rail-layout.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ContentRightRailLayoutComponent {
  @Input()
  container:
    | FilterableContainer
    | FilterableGrid
    | GridContainer
    | ContainerModel
    | TwoColumnContainerModel
    | undefined
    | null

  /**
   * Content above main. Usually used for leaderboard ads
   */
  @Input()
  topContent: ContainerModel | undefined | null

  /**
   * Right rail content
   */
  @Input()
  secondaryContainer: ContainerModel | undefined | null

  /**
   * Sticky bottom content
   */
  @Input()
  bottomContent: ContainerModel | undefined | null

  @Input()
  public imageWithButtons: ImageWithButtonsModel | null

  @Input()
  public description: ExpandableTextModel | undefined | null

  @Input()
  public geoBlockedIds: ReadonlyArray<number>

  @Input()
  message: MessageModel | undefined | null

  @Input()
  isLoading: boolean

  @Input()
  isPartialError: boolean

  @Input()
  hideRightRail: boolean

  @Input()
  selectedItem: VideoPlayerCard | undefined

  /**
   * Shows the CTA content section at the bottom of the
   * page for tablet screen sizes and smaller
   * CXP-6707 will provide updates, so we hopefully won't need this
   */
  @Input()
  showFooterCTA = false

  @Output()
  toggleClicked = new EventEmitter<FilterOptionModel>()

  @Output()
  nextPage = new EventEmitter<LinkModel>()

  trackById = trackById

  public handleNextPage(link: LinkModel) {
    this.nextPage.emit(link)
  }

  public handleToggleClicked(toggleOption: FilterOptionModel) {
    this.toggleClicked.emit(toggleOption)
  }
}
